import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatIcon } from '@angular/material/icon';

import { ERoutes } from 'src/app/core/enums/routes.enum';

import { ReplaceStrPipe } from 'src/app/shared/pipes/replace-str.pipe';
import { ESvgIcons } from 'src/app/core/enums/svg-icons';

@Component({
  selector: 'app-simple-breadcrumb',
  templateUrl: './simple-breadcrumb.component.html',
  styleUrls: ['./simple-breadcrumb.component.scss'],
  imports: [RouterModule, ReplaceStrPipe, MatIcon],
})
export class SimpleBreadcrumbComponent {
  @Input() breadcrumbs: any[] = [];

  public readonly eRoutes = ERoutes;
  public readonly eSvgIcons = ESvgIcons;
}
